var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "10px 20px" } },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "h4",
        [
          _vm._v("Manage Users\n    "),
          _c("custom-tooltip", { attrs: { "tooltip-text": _vm.tooltipInfo } })
        ],
        1
      ),
      _vm._v(" "),
      _c("user-page", {
        ref: "userPage",
        attrs: {
          roles: _vm.roles,
          groups: _vm.allGroups,
          "show-meta": false,
          "extra-menu": _vm.team.menu,
          "user-list": _vm.team.userList,
          defaultDropdownGroupId: _vm.defaultDropdownGroupId,
          "tooltip-size": 0.7
        },
        on: {
          exists: _vm.userExist,
          menuclick: _vm.menuClick,
          sendinvite: _vm.inviteUsers,
          addgroup: _vm.onAccessChange,
          rolechange: _vm.onAccessChange,
          removegroup: _vm.onAccessChange,
          sendallinvites: _vm.sendAllInvites,
          "sendpendinginvites-exist": _vm.userExist
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "bottom-action" }, [
        _c(
          "button",
          { staticClass: "continue simple", on: { click: _vm.inviteAllUsers } },
          [_vm._v("Invite Users")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n    Invite your Team members to DataMapper and decide what User Groups they will be part of.\n    "
      ),
      _c("br"),
      _vm._v(
        ' You may give Team members an "Admin" role for them to make changes to your DataMapper setup.\n    '
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-414b6ffe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-414b6ffe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./apps/account/Team.vue
// module id = 500
// module chunks = 0